import { Component, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/pages/search/services/search.service';
import { FundraiserCardData } from 'src/app/shared/interfaces/fundraiser-card-interface';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FundraiserCardComponent } from '../../../../../../shared/components/fundraiser-card/fundraiser-card.component';
import { NgClass, NgFor, SlicePipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-featured-fundraisers-homepage',
    templateUrl: './featured-fundraisers-homepage.component.html',
    styleUrls: ['./featured-fundraisers-homepage.component.scss'],
    standalone: true,
    imports: [FlexModule, ExtendedModule, NgClass, NgFor, FundraiserCardComponent, MatIconModule, MatButtonModule, SlicePipe]
})
export class FeaturedFundraisersHomepageComponent {
	_fundraiserCardDataList!: {
		slug: string;
		fundraiserCardData: FundraiserCardData;
	}[];

	constructor(
		private _searchService: SearchService,
		public router: Router,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		/** *Calling fundraisers for trending fundraisers */
		this._searchService.getPopularFundraiser().subscribe(
			(response) => {
			const responseData= (response as any)?.data;
			this._fundraiserCardDataList =
				this._searchService.getSearchFundraiserCardDataListElasticSearch(
					responseData
				);
			this.cdr.detectChanges();
		});
	}

	/*
	 * Route to search
	 */
	routeToSearch() {
		this.router.navigate(['search']);
	}

	scrollCards(direction: 'prev' | 'next'): void {
		const container = document.querySelector('.homepage-card-container');
		if (container) {
			const cardWidth = container.clientWidth;
			const scrollAmount = direction === 'prev' ? -cardWidth : cardWidth;
			container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		}
	}

	hasMoreData(direction: 'prev' | 'next'): boolean {
		const container = document.querySelector('.homepage-card-container');
		if (container) {
			const cardWidth = container.clientWidth;
			const maxScrollLeft = container.scrollWidth - container.clientWidth;
			const currentScrollLeft = container.scrollLeft;

			return direction === 'prev'
				? currentScrollLeft > 0
				: currentScrollLeft < maxScrollLeft;
		}

		return false;
	}
}
